import styled from 'styled-components';

export const StyledSearchForm = styled.form`
    width: 100%;
    background-color: white;
    border-radius: 20px;
    padding: 30px;
    box-shadow: 2px 2px 10px #d3d3d3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    column-gap: 30px;
    row-gap: 40px;
    margin-top: 50px;

    .link-to-table {
        display: inherit;
        text-decoration: none;
    };
`

export const StyledSearchInput = styled.input`
    background-color: transparent;
    width: 100%;
    height: 52px;
    border: none;
    border-bottom: 1px solid #a0a0a0;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
    };
    -moz-appearance: textfield;
`

export const StyledSearchButton = styled.button`
    background-color: var(--bllink-purple);
    height: 52px;
    text-transform: uppercase;
    border-radius: 5px;
    border: none;
    color: white;
    width: 200px;
    &:hover {
        background-color: #454bff;
    };
    &:disabled {
        background-color: #a9a9a9;
    }
`